export function evaluateExpression(formula, dataRow, columnTypes) {
    formula = formula.replace(/IIF\(([^,]+),([^,]+),([^)]+)\)/gi, (_, cond, t, f) => {
      return `(${cond.trim()}) ? (${t.trim()}) : (${f.trim()})`;
    });
  
    formula = formula.replace(/'([^']*)'/g, `"${'$1'}"`); // single quotes ➜ double
    formula = formula.replace(/([^<>=!])=([^=])/g, '$1==$2'); // = ➜ ==
    formula = formula.replace(/\{(.*?)\}/g, (_, key) => key.trim().toLowerCase()); // {X} ➜ x
  
    const context = {};
    for (const key in dataRow) {
      const safeKey = key.toLowerCase();
      const val = dataRow[key];
      context[safeKey] = val;
    }
  
    try {
      const args = Object.keys(context).join(', ');
      const values = Object.values(context);
      const fn = new Function(args, `return ${formula};`);
      return String(fn(...values));
    } catch (err) {
      console.error('Evaluation error:', err.message);
      return '';
    }
}